<template>
  <div class="ub-box">
    <div class="ub-f1 z-width-100-precent z-textAlign-center">
      <span class="z-display-inlineBlock z-width-33-precent z-lineHeight-30 li-bottom-line" v-for="(title, index) in columns" :data-key="title.key">{{title.label}}</span>
      <div class="">
      <li v-for="(item, index) in data" class="ub-box z-textAlign-center z-lineHeight-30 li-bottom-line">
        <span class="xul z-textAlign-center z-width-33-precent z-display-block" v-for="(column, ind) in columns">
          <xcell :cell-config="item[column['col']]" :cell-string="item[column['key']]" :index="index" :cell-index="ind" :string-before="column.stringBefore" :category="column.category"/>
        </span>
      </li>
      </div>
    </div>
  </div>
</template>

<script>
  import Xcell from './Xcell.vue'
  export default {
    data() {
      return {
        type: 'sort',
        oldKey: ''
      }
    },
    props: {
      columns: {
        type: Array,
        default:()=> []
      },
      data: {
        type: Array,
        default:()=>[]
      }
    },
    components: {
      Xcell,
    },
    methods: {

    }
  }
</script>

<style scoped>
  ul li {list-style: none; }
  li:hover {background-color: #f9f9f9;}
  .li-bottom-line { border-bottom: 1px solid #eee;}
  .xul { overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }
  .xul span {display: inline-block;}
</style>



// WEBPACK FOOTER //
// src/components/commons/Xul.vue